export default "__VITE_ASSET__DrO$4Moj__"